import { render, staticRenderFns } from "./ProfilingModal.vue?vue&type=template&id=7b06d081"
import script from "./ProfilingModal.vue?vue&type=script&lang=js"
export * from "./ProfilingModal.vue?vue&type=script&lang=js"
import style0 from "./ProfilingModal.vue?vue&type=style&index=0&id=7b06d081&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports